import { WidgetType } from 'domain/entity/widget';
import WidgetData, { Color, Period, WidgetDataAvailability } from 'domain/entity/widgetData';
import { WidgetDescription } from '../widgetData';

export type WidgetGaugeData = WidgetData & {
    checkpoints: WidgetChartLimit[];
    comparison: WidgetGaugeComparison;
    gaugeType: string;
    indicator: WidgetGaugeIndicator;
    max: number;
    min: number;
    ranges: WidgetGaugeRange[];
    showAsPercentage: boolean;
    units: string;
};
export class WidgetGaugeComparison {
    constructor(
        readonly color: Color,
        readonly enabled: boolean,
        readonly period: Period,
        readonly showAsPercentage: boolean,
        readonly value: string
    ) {}
}
export class WidgetGaugeIndicator {
    constructor(readonly color: Color, readonly value: number, readonly name?: string) {}
}

export class WidgetChartLimit {
    constructor(readonly color: Color, readonly value: number, readonly name?: string) {}
}

export class WidgetGaugeRange {
    constructor(readonly color: Color, readonly from: number, readonly to: number, readonly name: string) {}
}

class GaugeData implements WidgetGaugeData {
    type = WidgetType.GAUGE;

    constructor(
        readonly checkpoints: WidgetChartLimit[],
        readonly comparison: WidgetGaugeComparison,
        readonly dataAvailability: WidgetDataAvailability,
        readonly description: WidgetDescription,
        readonly gaugeType: string,
        readonly indicator: WidgetGaugeIndicator,
        readonly max: number,
        readonly min: number,
        readonly ranges: WidgetGaugeRange[],
        readonly showAsPercentage: boolean,
        readonly units: string
    ) {}
}

export default GaugeData;
